import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface GameIdea {
  game_title: string
  game_description: string
  asset_description: string
  art_style: string
  game_type: string
  player_movement: string
  game_keywords: string
}

export interface GameIdeaState {
  promptId: string
  generateStatus: string | null
  gameIdea: GameIdea
}

const initialState: GameIdeaState = {
  promptId: '',
  generateStatus: null,
  gameIdea: {
    game_title: '',
    game_description: '',
    asset_description: '',
    art_style: '',
    game_type: '',
    player_movement: '',
    game_keywords: '',
  },
}

export const gameIdeaSlice = createSlice({
  name: 'gameIdea',
  initialState,
  reducers: {
    updateGameIdeaState: (state, action: PayloadAction<Partial<GameIdeaState>>) => {
      return { ...state, ...action.payload }
    },
    setGameIdea: (state, action: PayloadAction<Partial<GameIdea>>) => {
      state.gameIdea = { ...state.gameIdea, ...action.payload }
    },
    setGenerateStatus: (state, action: PayloadAction<string | null>) => {
      state.generateStatus = action.payload
    },
    clearGameIdea: (state) => {
      state.promptId = ''
      state.generateStatus = null
      state.gameIdea = {
        game_title: '',
        game_description: '',
        asset_description: '',
        art_style: '',
        game_type: '',
        player_movement: '',
        game_keywords: '',
      }
    },
  },
})

export const { updateGameIdeaState, setGameIdea, setGenerateStatus, clearGameIdea } =
  gameIdeaSlice.actions

export default gameIdeaSlice.reducer
